
export interface IWorkflowStatusViewModel {
  doc_No: string,
  doc_Title: string,
  doc_Id: number,
  workflow_Id: number,
  workflow_Task: string,
  revision_No: string,
  member_Name: string,
  assigned_On: string,
  completed_On: string,
  status: string,
  action_Status: string
}

export interface IWorkflowStatusInputModel {
  Project_Id: number|null,
  Group_Id: number|null,
  discipline_Id? : number|null,
  structure_Id? : number|null,
  drg_Type?:string|null,
  Search_Text: string|null,
  isLatest: boolean
}

export interface IWorkflowStatusCLOutputModel {
  clId: number,
  clName: string,
  clRevisionNo: number,
  clShortName: string
  documentId: number,
  documentNumber: string,
  documentRevisionNo: string,
  documentTitle: string,
  memberId: number,
  taskSerialNumber: number,
  uploadedBy: number,
  uploadedByName: string,
  uploadedOn: string,
  workflowId: number
}
export interface IWorkflowStatusCCNViewModel {
  ccnId: number,
  ccnNo: string,
  ccnTitle: string,
  ccnDescription: string,
  ccnRevNo: number,
  ccN_Date: string,
  discipline: string,
  orginator: string,
  man_Hour: number
}
